import {mapState} from "vuex";
import {debounce} from 'lodash';

export const commonStoreMixin = {
    data() {
        return {
            searchQuery: "",
            pagination: {
                itemsPerPage: 25,
            },
            footerProps: {
                'items-per-page-options': [25,50,100,200,300,500,1000,{text: 'All', 'value': -1}]
            },
            commonState: null,
            stateName: null,
            progressLinearLoading: false,
        }
    },
    computed: {
        ...mapState({
            loading(state) {
                return state[this.stateName]['loading'];
            },
            disablePrev(state) {
                if (state[this.stateName] !== undefined)
                    return state[this.stateName]['disablePrev'];

                return true;
            },
            disableNext(state) {

                if (state[this.stateName] !== undefined)
                    return state[this.stateName]['disableNext'];

                return true;
            },
            data(state) {
                if (state[this.stateName] !== undefined)
                    return state[this.stateName]['data'];

                return [];
            },
            links(state) {
                return state[this.stateName]['links']
            },
            totalItemsLoading(state) {
                if (state[this.stateName] !== undefined)
                    return state[this.stateName]['totalItemsLoading'];

                return 0;
            },
            total(state) {
                if (state[this.stateName] !== undefined)
                    return state[this.stateName]['totalItems'];

                return 0;

            },
            showingOf(state) {
                if (state[this.stateName] !== undefined) {
                    if (this.data.length === 0)
                        return 0;

                    let s_no = this.data.map((i) => i.s_no);
                    return Math.max(...s_no);
                }
                return 0;
            },
            filters(state) {
                if (state[`${this.stateName}`] !== undefined) {
                    return state[`${this.stateName}`]['filters'];
                }
                return {};
            }
        }),
    },
    watch: {
        pagination: debounce(function () {
            this.setServerPagination(this.pagination);
            this.fetchData();
        }, 100),
        searchQuery: debounce(function () {
            this.setServerQuery(this.searchQuery);
            this.fetchData()
        }, 1000)
    },
    methods: {
        handleNextClick() {
            this.fetchData('next')
        },
        handlePrevClick() {
            this.fetchData('prev')
        },
        fetchDataWithRow(row) {
            this.pagination.itemsPerPage = row;
        },
        fetchFiltersData() {
            this.fetchData()
        },
        fetchData(data = null) {
            return this.$store.dispatch(`${this.stateName}/fetchData`, data)
        },
        getCount(data = null) {
            return this.$store.dispatch(`${this.stateName}/getCount`, data)
        },
        exportData(data = null) {
            return this.$store.dispatch(`${this.stateName}/exportData`, data)
        },
        handleRowChange(data = null) {
            return this.$store.commit(`${this.stateName}/handleRowChange`, data)
        },
        setServerPagination(data = null) {
            return this.$store.commit(`${this.stateName}/setServerPagination`, data)
        },
        setServerQuery(data = null) {
            return this.$store.commit(`${this.stateName}/setServerQuery`, data)
        },
        setFilters(data = null) {
            return this.$store.commit(`${this.stateName}/setFilter`, data)
        }
    },

};
